import React, {Component} from 'react';
import {Footer, NavBar, Session} from "../../components";
import {VIEW_NAME} from "../../libs/utils/Const";

class ProfileView extends Component {
    render() {
        const {history} = this.props;
        return (
            <div className="content-fluid" style={{marginTop: 109}}>
                <Session history={history} view={VIEW_NAME.PROFILE_VIEW}/>
                <NavBar/>
                <h4>Mi información:</h4>
            </div>
        );
    }
}

export default ProfileView;